import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'isVaultImage' })
export class IsVaultImagePipe implements PipeTransform {
  transform(value: string) {
    return typeof value === "string" && value.split("/").pop().startsWith("59_");
  }
}
